import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import getUser from 'Utils/userAuth';
import { token as localStorageToken } from 'Utils/envLoader';

const AuthVerify = ({ history, logOut }) => {
    let historyLisetener;
    useEffect(() => {
        historyLisetener = history.listen(() => {
            const token = localStorage.getItem(localStorageToken);
            if (token) {
                const decodedJwt = getUser(token);
                if (decodedJwt.exp * 1000 < Date.now()) {
                    logOut();
                }
            } else logOut();
        });
        return () => {
            historyLisetener();
        };
    }, []);

    return <></>;
};

export default withRouter(AuthVerify);
